var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-layout',[_c('sp-list',{attrs:{"endpoint":"SPARTA_GQL:spartaSubscription","attrs":_vm.columns,"params":_vm.params,"actions":['search', 'settings', 'refresh']}},[_c('sp-list-table',{staticClass:"pt-0",attrs:{"sticky-header":"","reorder":true},scopedSlots:_vm._u([{key:"name",fn:function(ref){
var item = ref.item;
return [_c('p',[_vm._v(_vm._s(item.name.split(" ")[0]))])]}},{key:"duration",fn:function(ref){
var item = ref.item;
return [_c('p',{staticClass:"text-capitalize"},[_vm._v(_vm._s(item.duration))])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }